import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { useErisInformationStore } from 'src/api/eris/store/ErisInformationStore';
import { columns, conditionalRowStyles } from './ErisStatusResultsTableColumns';
import { ErisStatusResultsTableLegend } from './ErisStatusResultsTableLegend';
import { ErisStatusResultsTablePaginationHeader } from './ErisStatusResultsTablePaginationHeader';
import useGroupService from 'src/api/eris/service/ErisInformationService';
import useDisasterService from 'src/api/eris/service/ErisDisasterService';

const customStyles = {
  table: {
    style: {
      maxHeight: 'none',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1e3a8a',
      color: '#ffffff',
      fontWeight: 'bold',
      borderRight: '2px solid #ccc',
      borderBottom: '2px solid #ccc',
      fontSize: '1rem',
    },
  },
  cells: {
    style: {
      paddingLeft: '0',
      paddingRight: '0.5rem',
      borderRight: '2px solid #ccc',
      borderBottom: '2px solid #ccc',
      fontSize: '1rem',
    },
  },
};

const ErisResultsTable = () => {
  const { t } = useTranslation();
  const { searchGroupStatus } = useGroupService();
  const { getLatestDisaster } = useDisasterService();
  const statusResult = useErisInformationStore((state) => state.statusResult);
  const isLoading = useErisInformationStore((state) => state.isSearchingResults);
  const { pageNumber, pageSize, searchParams } = useErisInformationStore(
    (state) => state.statusSearchingParameters
  );
  const patchStatusPagination = useErisInformationStore((state) => state.patchStatusPagination);

  const handlePageChange = (newPage: number) => {
    const newPageNumber = newPage - 1;
    if (newPageNumber !== pageNumber) {
      const nextParams = {
        pageNumber: newPageNumber,
        pageSize,
        searchParams,
      };
      patchStatusPagination({ pageNumber: newPageNumber });
      searchGroupStatus(nextParams);
      getLatestDisaster();
    }
  };

  const handleChangeRowsPerPage = (newSize: number) => {
    if (newSize !== pageSize) {
      const nextParams = {
        pageNumber: 0,
        pageSize: newSize,
        searchParams,
      };
      patchStatusPagination({ pageSize: newSize, pageNumber: 0 });
      searchGroupStatus(nextParams);
    }
  };

  return (
    <div className="h-auto max-h-none w-full overflow-visible">
      {statusResult?.pageElements && statusResult?.pageElements.length > 0 && (
        <ErisStatusResultsTablePaginationHeader
          page={pageNumber + 1}
          perPage={pageSize}
          total={statusResult?.totalElements ?? 0}
          onPageChange={handlePageChange}
          onPerPageChange={handleChangeRowsPerPage}
        />
      )}
      <DataTable
        className="pb-4"
        noDataComponent={t('eris.common.noResults')}
        columns={columns(pageNumber, pageSize, t)}
        data={statusResult?.pageElements ?? []}
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        progressPending={isLoading}
      />
      <ErisStatusResultsTableLegend t={t} />
    </div>
  );
};

export default ErisResultsTable;
